import React, { ReactElement, ReactNode } from 'react';

interface I18nWithLoginwallFallbackTexts {
    (key: 'loginwall_title', params: { br: ReactElement }): ReactNode;
    (key: 'loginwall_subtitle'): ReactNode;
}

export const getLoginwallFallbackTexts = (i18n: I18nWithLoginwallFallbackTexts) => ({
    title: i18n('loginwall_title', { br: <br /> }),
    subtitle: i18n('loginwall_subtitle'),
});
